import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  writeBatch,
} from "firebase/firestore";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { Button, Input, Modal, ModalBody } from "reactstrap";
import { IoClose } from "react-icons/io5";
import Swal from "sweetalert2";

import { v4 as uuidv4 } from "uuid";
import emailjs from "@emailjs/browser";

function AdminSingleGroupPage() {
  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const groupUid = params.groupUid;

  // eslint-disable-next-line
  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setUserData(data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  // eslint-disable-next-line
  const [group, setGroup] = useState();
  const [groupName, setGroupName] = useState();
  const [sport, setSport] = useState();
  const [league, setLeague] = useState();
  const [season, setSeason] = useState();
  const [openingDateTime, setOpeningDateTime] = useState();
  const [closingDateTime, setClosingDateTime] = useState();
  const [events, setEvents] = useState([]);
  const [homeTeam, setHomeTeam] = useState();
  const [awayTeam, setAwayTeam] = useState();
  const [eventIsStarGame, setEventIsStarGame] = useState();

  const fetchGroup = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "groups"), where("uid", "==", groupUid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();

      setGroup(data);
      setGroupName(data.name);
      setSport(data.sport);
      setLeague(data.league);
      // phase removed
      // support legacy `season` and new `tournament` field
      setSeason(data.tournament || data.season);
      setOpeningDateTime(data.openingDateTime);
      setClosingDateTime(data.closingDateTime);
      setEvents(data.events);

      if (data.sport === "Racing") {
        if (data.fastestLap) {
          setFastestLapDriver(data.fastestLap);
        }
      }

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching group");
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (groupUid) {
      fetchGroup();
    }
    // eslint-disable-next-line
  }, [groupUid]);

  const sports = [
    // 'Test',
    "Soccer",
    "Football",
    "Baseball",
    "Hockey",
    "Racing",
    "Basketball",
    "MMA",
    // 'College football',
    // 'College Basketball'
  ];

  const [leagues, setLeagues] = useState();
  const [teams, setTeams] = useState();

  const fetchLeagues = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "leagues"));
      const doc = await getDocs(q);
      const data = doc.docs.map((doc) => doc.data());

      let fetchedTeams = [];
      data.forEach((league) => {
        if (league.teams) {
          league.teams.forEach((team) => {
            fetchedTeams.push({
              league: league.name,
              name: team.name,
            });
          });
        }
      });

      setLeagues(data);
      setTeams(fetchedTeams);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching leagues");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLeagues();
    // eslint-disable-next-line
  }, []);

  // const leagues = [
  // 	// {
  // 	// 	sport: 'Test',
  // 	// 	leagues: [
  // 	// 		'Test League',
  // 	// 	]
  // 	// },
  // 	{
  // 		sport: 'Soccer',
  // 		leagues: [
  // 			'Premier League',
  // 			'LaLiga',
  // 			'Serie A',
  // 			'Bundesliga',
  // 			'Ligue 1',
  // 			'UEFA Champions League',
  // 			'UEFA Europa League',
  // 			'FIFA World Cup',
  // 			'UEFA European Championship',
  // 			'Copa America',
  // 			'CONCACAF Gold Cup',
  // 			'Africa Cup of Nations',
  // 			'FIFA Club World Cup',
  // 			'FIFA Confederations Cup',
  // 			'FIFA U-20 World Cup',
  // 			'FIFA U-17 World Cup'
  // 		]
  // 	},
  // 	{
  // 		sport: 'Football',
  // 		leagues: [
  // 			'NFL',
  // 			'NCAA',
  // 			'Canadian Football League',
  // 			'Arena Football League',
  // 			'XFL',
  // 			'USFL',
  // 			'NFL Europe',
  // 			'World League of American Football',
  // 			'United Football League',
  // 			'Alliance of American Football'
  // 		]
  // 	},
  // 	{
  // 		sport: 'Racing',
  // 		leagues: [
  // 			'Formula 1',
  // 		]
  // 	}
  // ]

  // // eslint-disable-next-line
  // const [teams, setTeams] = useState([
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Arsenal'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Aston Villa'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Brentford'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Brighton & Hove Albion'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Burnley'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Chelsea'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Crystal Palace'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Everton'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Leeds United'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Leicester City'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Liverpool'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Manchester City'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Manchester United'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Newcastle United'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Norwich City'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Southampton'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Tottenham Hotspur',
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Watford'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'West Ham United'
  // 	},
  // 	{
  // 		league: 'Premier League',
  // 		team: 'Wolverhampton Wanderers'
  // 	}
  // {
  // 	league: 'Test League',
  // 	teams: [
  // 		'Test team 1',
  // 		'Test team 2',
  // 		'Test team 3',
  // 		'Test team 4',
  // 		'Test team 5',
  // 		'Test team 6',
  // 		'Test team 7',
  // 		'Test team 8',
  // 		'Test team 9',
  // 		'Test team 10',
  // 		'Test team 11',
  // 		'Test team 12',
  // 		'Test team 13',
  // 		'Test team 14',
  // 		'Test team 15',
  // 		'Test team 16',
  // 		'Test team 17',
  // 		'Test team 18',
  // 		'Test team 19',
  // 		'Test team 20'
  // 	]
  // },
  // {
  // 	league: 'Premier League',
  // 	teams: [
  // 		'Arsenal',
  // 		'Aston Villa',
  // 		'Brentford',
  // 		'Brighton & Hove Albion',
  // 		'Burnley',
  // 		'Chelsea',
  // 		'Crystal Palace',
  // 		'Everton',
  // 		'Leeds United',
  // 		'Leicester City',
  // 		'Liverpool',
  // 		'Manchester City',
  // 		'Manchester United',
  // 		'Newcastle United',
  // 		'Norwich City',
  // 		'Southampton',
  // 		'Tottenham Hotspur',
  // 		'Watford',
  // 		'West Ham United',
  // 		'Wolverhampton Wanderers'
  // 	]
  // },
  // {
  // 	league: 'LaLiga',
  // 	teams: [
  // 		'Alavés',
  // 		'Athletic Bilbao',
  // 		'Atlético Madrid',
  // 		'Barcelona',
  // 		'Cádiz',
  // 		'Celta Vigo',
  // 		'Eibar',
  // 		'Elche',
  // 		'Espanyol',
  // 		'Getafe',
  // 		'Granada',
  // 		'Huesca',
  // 		'Levante',
  // 		'Mallorca',
  // 		'Osasuna',
  // 		'Rayo Vallecano',
  // 		'Real Betis',
  // 		'Real Madrid',
  // 		'Real Sociedad',
  // 		'Sevilla',
  // 		'Valencia',
  // 		'Valladolid',
  // 		'Villarreal'
  // 	]
  // }
  // ]
  // )

  const [createEventModalIsVisible, setCreateEventModalIsVisible] =
    useState(false);
  const toggleCreateEventModal = () => {
    setCreateEventModalIsVisible(!createEventModalIsVisible);
  };

  const createEvent = async () => {
    try {
      setIsLoading(true);

      const newEvent = {
        homeTeam: homeTeam,
        awayTeam: awayTeam,
        isStarGame: eventIsStarGame === "true" || eventIsStarGame === true,
        result: null,
      };
      const newEvents = events ? [...events, newEvent] : [newEvent];
      setEvents(newEvents);

      const newTaken = teamsTaken
        ? [...teamsTaken, homeTeam, awayTeam]
        : [homeTeam, awayTeam];
      setTeamsTaken(newTaken);

      // reset local inputs
      setHomeTeam();
      setAwayTeam();
      setEventIsStarGame(false);

      // Update all sibling groups (tournament type variants)
      const q = query(collection(db, "groups"), where("uid", "==", group.uid));
      const findGroups = await getDocs(q);
      const primaryGroupSnap = findGroups.docs[0];
      const primaryGroupData = primaryGroupSnap.data();

      const siblingDocs = await findSiblingGroupDocs(primaryGroupData);

      console.log(
        `Adding event to ${siblingDocs.length} group variant(s) for tournament`
      );

      // Batch update all sibling groups
      const batch = writeBatch(db);
      siblingDocs.forEach((sibling) => {
        const groupRef = doc(db, "groups", sibling.id);
        batch.update(groupRef, {
          events: newEvents,
        });
      });

      await batch.commit();

      setCreateEventModalIsVisible(false);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while creating event");
      setCreateEventModalIsVisible(false);
      setIsLoading(false);
    }
  };

  const [teamsTaken, setTeamsTaken] = useState([]);

  const [eventToEdit, setEventToEdit] = useState();
  const [eventToEditHomeTeam, setEventToEditHomeTeam] = useState();
  const [eventToEditAwayTeam, setEventToEditAwayTeam] = useState();
  const [eventToEditIsStarGame, setEventToEditIsStarGame] = useState();
  const [editEventModalIsVisible, setEditEventModalIsVisible] = useState(false);
  const toggleEditEventModal = (event) => {
    if (event) {
      setEventToEdit(event);
      setEventToEditHomeTeam(event.homeTeam);
      setEventToEditAwayTeam(event.awayTeam);
      setEventToEditIsStarGame(event.isStarGame);
    }
    setEditEventModalIsVisible(!editEventModalIsVisible);
  };

  const saveChangesToEvent = async () => {
    try {
      setIsLoading(true);

      let newEvents = events;
      newEvents.forEach((ev) => {
        if (
          ev.homeTeam === eventToEdit.homeTeam &&
          ev.awayTeam === eventToEdit.awayTeam
        ) {
          ev.homeTeam = eventToEditHomeTeam;
          ev.awayTeam = eventToEditAwayTeam;
          ev.isStarGame = eventToEditIsStarGame === "true" ? true : false;
        }
      });

      let newTeamsTaken = teamsTaken;
      newTeamsTaken = newTeamsTaken.filter((team) => {
        return team !== eventToEdit.homeTeam && team !== eventToEdit.awayTeam;
      });
      newTeamsTaken.push(eventToEditHomeTeam);

      setEvents(newEvents);
      setTeamsTaken(newTeamsTaken);

      // Update all sibling groups (tournament type variants)
      const q = query(collection(db, "groups"), where("uid", "==", group.uid));
      const findGroups = await getDocs(q);
      const primaryGroupSnap = findGroups.docs[0];
      const primaryGroupData = primaryGroupSnap.data();

      const siblingDocs = await findSiblingGroupDocs(primaryGroupData);

      console.log(
        `Updating event in ${siblingDocs.length} group variant(s) for tournament`
      );

      // Batch update all sibling groups
      const batch = writeBatch(db);
      siblingDocs.forEach((sibling) => {
        const groupRef = doc(db, "groups", sibling.id);
        batch.update(groupRef, {
          events: newEvents,
        });
      });

      await batch.commit();

      toggleEditEventModal();
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while updating event");
      toggleEditEventModal();
      setIsLoading(false);
    }
  };

  const deleteEvent = async () => {
    try {
      setIsLoading(true);

      let newEvents = events;
      newEvents = newEvents.filter((event) => {
        return (
          event.homeTeam !== eventToEdit.homeTeam &&
          event.awayTeam !== eventToEdit.awayTeam
        );
      });

      let newTeamsTaken = teamsTaken;
      newTeamsTaken = newTeamsTaken.filter((team) => {
        return team !== eventToEdit.homeTeam && team !== eventToEdit.awayTeam;
      });
      setTeamsTaken(newTeamsTaken);

      setEvents(newEvents);

      // Update all sibling groups (tournament type variants)
      const q = query(collection(db, "groups"), where("uid", "==", group.uid));
      const findGroups = await getDocs(q);
      const primaryGroupSnap = findGroups.docs[0];
      const primaryGroupData = primaryGroupSnap.data();

      const siblingDocs = await findSiblingGroupDocs(primaryGroupData);

      console.log(
        `Deleting event from ${siblingDocs.length} group variant(s) for tournament`
      );

      // Batch update all sibling groups
      const batch = writeBatch(db);
      siblingDocs.forEach((sibling) => {
        const groupRef = doc(db, "groups", sibling.id);
        batch.update(groupRef, {
          events: newEvents,
        });
      });

      await batch.commit();

      toggleEditEventModal();
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while deleting event");
      toggleEditEventModal();
      setIsLoading(false);
    }
  };

  const saveGroupChanges = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "groups"), where("uid", "==", group.uid));
      const findGroups = await getDocs(q);
      const primaryGroupSnap = findGroups.docs[0];
      const primaryGroupData = primaryGroupSnap.data();

      // Find all sibling groups (tournament type variants)
      const siblingDocs = await findSiblingGroupDocs(primaryGroupData);

      console.log(
        `Updating ${siblingDocs.length} group variant(s) for tournament`
      );

      // Batch update all sibling groups
      // IMPORTANT: Do NOT update events here - events have their own dedicated functions
      // (saveChangesToEvent, deleteEvent, addEvent) to prevent data loss
      const batch = writeBatch(db);
      siblingDocs.forEach((sibling) => {
        const groupRef = doc(db, "groups", sibling.id);
        batch.update(groupRef, {
          name: groupName,
          sport: sport,
          league: league,
          // write to new `tournament` field (keeps legacy `season` untouched)
          tournament: season,
          openingDateTime: openingDateTime,
          closingDateTime: closingDateTime,
          // events: events, // REMOVED - events should only be updated via dedicated event functions
        });
      });

      await batch.commit();

      fetchGroup();
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while updating group");
      setIsLoading(false);
    }
  };

  const deleteGroup = async () => {
    Swal.fire({
      text: "Are you sure you want to delete this group? This will delete all tournament type variants (casual, standard, highStakes, vipExclusive).",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, DELETE ALL VARIANTS",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const groupRef = query(
            collection(db, "groups"),
            where("uid", "==", group.uid)
          );
          const findGroups = await getDocs(groupRef);
          const primaryGroupSnap = findGroups.docs[0];
          const primaryGroupData = primaryGroupSnap.data();

          // Find all sibling groups (tournament type variants)
          const siblingDocs = await findSiblingGroupDocs(primaryGroupData);

          console.log(
            `Deleting ${siblingDocs.length} group variant(s) for tournament`
          );

          // Batch delete all sibling groups
          const batch = writeBatch(db);
          siblingDocs.forEach((sibling) => {
            const groupRef = doc(db, "groups", sibling.id);
            batch.delete(groupRef);
          });

          await batch.commit();

          Swal.fire({
            text: `${siblingDocs.length} group variant(s) deleted successfully`,
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          navigate(-1);

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting group");
        }
      }
    });
  };

  // eslint-disable-next-line
  const sendResultSubmissionNotifications = async (
    leagueName,
    groupName,
    recipientUid,
    recipientEmail,
    recipientUsername,
    recipientLanguage,
    leagueUid,
    roomUid
  ) => {
    try {
      // In-app notification is now handled by batch in checkIfAllResultsAreInAndNotify
      // This function now only handles email sending

      // Send email notification with per-recipient localization
      const serviceId = "sportleague_outlook";
      const templateId = "resultSubmission";
      const publicKey = "Ki5BETKiWrS6RDEP_";

      // Translation map for result submission email
      const emailTranslations = {
        en: {
          subject: "Results are in for {leagueName}'s {groupName}!",
          greeting: "Hi",
          paragraphIntro:
            "The results for <strong>{leagueName}</strong>'s <em>{groupName}</em> are in!",
          paragraphAction:
            "Click the button below to view the full results in the room.",
          buttonText: "GO TO SPORTLEAGUE",
          fallbackIntro:
            "If the button above doesn't work, copy and paste this link into your browser:",
          footerNotice:
            "You are receiving this email because you're a member of {leagueName}.",
          copyright: "© 2025 Sportleague. All rights reserved.",
        },
        es: {
          subject: "¡Resultados de {groupName} en {leagueName}!",
          greeting: "Hola",
          paragraphIntro:
            "¡Los resultados de <strong>{groupName}</strong> en <strong>{leagueName}</strong> ya están disponibles!",
          paragraphAction:
            "Haz clic en el botón para ver los resultados completos en la sala.",
          buttonText: "IR A SPORTLEAGUE",
          fallbackIntro:
            "Si el botón anterior no funciona, copia y pega este enlace en tu navegador:",
          footerNotice:
            "Recibes este correo porque eres miembro de {leagueName}.",
          copyright: "© 2025 Sportleague. Todos los derechos reservados.",
        },
      };

      const lang = recipientLanguage || "en";
      const t = emailTranslations[lang] || emailTranslations["en"];

      const subject = (t.subject || "")
        .replace("{leagueName}", leagueName)
        .replace("{groupName}", groupName);

      const paragraphIntro = (t.paragraphIntro || "")
        .replace("{leagueName}", leagueName)
        .replace("{groupName}", groupName);

      const paragraphAction = t.paragraphAction || "";
      const fallbackIntro = t.fallbackIntro || "";
      const footerNotice = (t.footerNotice || "").replace(
        "{leagueName}",
        leagueName
      );
      const copyright = t.copyright || "";

      // Validate required parameters
      if (!recipientEmail) {
        console.warn(
          `Skipping email for ${recipientUsername}: no email address`
        );
        return;
      }
      if (!leagueUid || !roomUid) {
        console.warn(
          `Skipping email for ${recipientEmail}: missing leagueUid or roomUid`
        );
        return;
      }

      const templateParams = {
        toEmail: recipientEmail,
        toUsername: recipientUsername,
        leagueName: leagueName,
        groupName: groupName,
        linkToRoom: `https://app.sportleague.com/play/leagues/${leagueUid}/rooms/${roomUid}`,
        subject,
        greeting: t.greeting,
        paragraphIntro,
        paragraphAction,
        buttonText: t.buttonText,
        fallbackIntro,
        footerNotice,
        copyright,
      };

      await emailjs.send(serviceId, templateId, templateParams, publicKey);
      console.log(`✓ Email sent successfully to ${recipientEmail}`);
    } catch (err) {
      console.error(`✗ Email send failed for ${recipientEmail}:`, err);
      // Don't throw - let it fail gracefully
    }
  };

  const checkIfAllResultsAreInAndNotify = async (groupData) => {
    const allEventsSubmitted = groupData.events?.every((event) => event.result);
    const isRacing = groupData.sport === "RACING";
    const allDriverResultsSubmitted = groupData.drivers?.every(
      (driver) => driver.result
    );
    const fastestLapSubmitted = !!groupData.fastestLap;

    const allResultsSubmitted = isRacing
      ? allDriverResultsSubmitted && fastestLapSubmitted
      : allEventsSubmitted;

    console.log(`📊 Results check for "${groupData.name}":`, {
      allResultsSubmitted,
      resultsNotificationSent: groupData.resultsNotificationSent,
      eventCount: groupData.events?.length,
      eventsWithResults: groupData.events?.filter((e) => e.result).length,
    });

    if (!allResultsSubmitted) {
      console.log(`⏸️ Not all results submitted yet for "${groupData.name}"`);
      return;
    }

    if (groupData.resultsNotificationSent) {
      console.log(`⏭️ Notifications already sent for "${groupData.name}"`);
      return;
    }

    const q1 = query(
      collection(db, "rooms"),
      where("leagueName", "==", groupData.league)
    );
    const findRooms = await getDocs(q1);

    // Collect all unique user UIDs across all rooms
    const allUserUids = new Set();
    const roomsData = [];
    findRooms.docs.forEach((roomDoc) => {
      const roomData = roomDoc.data();
      roomsData.push(roomData);
      roomData.members?.forEach((member) => {
        if (member.uid) allUserUids.add(member.uid);
      });
    });

    // Fetch all users in parallel (batch query)
    const userCache = new Map();
    if (allUserUids.size > 0) {
      const userUidsArray = Array.from(allUserUids);
      // Firestore 'in' query supports up to 10 items, so chunk if needed
      const chunkSize = 10;
      const userQueries = [];
      for (let i = 0; i < userUidsArray.length; i += chunkSize) {
        const chunk = userUidsArray.slice(i, i + chunkSize);
        const q = query(collection(db, "users"), where("uid", "in", chunk));
        userQueries.push(getDocs(q));
      }
      const userSnapshots = await Promise.all(userQueries);
      userSnapshots.forEach((snapshot) => {
        snapshot.docs.forEach((userDoc) => {
          const userData = userDoc.data();
          if (userData.uid) {
            userCache.set(userData.uid, userData);
          }
        });
      });
    }

    const leagueUid = leagues?.find((l) => l.name === groupData.league)?.uid;

    if (!leagueUid) {
      console.error(
        `Cannot send notifications: leagueUid not found for league "${groupData.league}"`
      );
      return;
    }

    // Send notifications in parallel (fire-and-forget for emails)
    const notificationPromises = [];
    const batch = writeBatch(db);
    let emailCount = 0;
    let skippedCount = 0;

    roomsData.forEach((roomData) => {
      if (!roomData.uid) {
        console.warn(`Skipping room: missing roomData.uid`);
        return;
      }

      roomData.members?.forEach((member) => {
        const user = userCache.get(member.uid);
        if (user) {
          if (!user.email) {
            console.warn(
              `Skipping user ${user.username || member.uid}: no email address`
            );
            skippedCount++;
            return;
          }
          emailCount++;
          // Add in-app notification to batch
          const newNotificationRef = doc(collection(db, "notifications"));
          const newNotification = {
            uid: uuidv4(),
            title: "Results are in!",
            description: `The results for ${groupData.league}'s ${groupData.name} are in!`,
            recipientUid: user.uid,
            dateCreated: new Date().toISOString(),
            isRead: false,
          };
          batch.set(newNotificationRef, newNotification);

          // Fire-and-forget email (don't await)
          notificationPromises.push(
            sendResultSubmissionNotifications(
              groupData.league,
              groupData.name,
              user.uid,
              user.email,
              user.username,
              user.language?.value,
              leagueUid,
              roomData.uid
            ).catch((err) => console.error("Email send failed:", err))
          );
        } else {
          console.warn(`User not found in cache: ${member.uid}`);
          skippedCount++;
        }
      });
    });

    console.log(
      `📧 Sending ${emailCount} result notification emails for "${groupData.name}" (${skippedCount} skipped)`
    );

    // Commit all in-app notifications at once
    await batch.commit();

    // Mark notification sent on all sibling groups
    const qGroup = query(
      collection(db, "groups"),
      where("uid", "==", groupData.uid)
    );
    const foundGroups = await getDocs(qGroup);
    const groupBatch = writeBatch(db);
    foundGroups.forEach((docSnap) => {
      const ref = doc(db, "groups", docSnap.id);
      groupBatch.update(ref, {
        resultsNotificationSent: true,
      });
    });
    await groupBatch.commit();

    // Let emails complete in background (optional: could remove this line entirely)
    Promise.all(notificationPromises).catch((err) =>
      console.error("Some emails failed:", err)
    );
  };

  // Helper: find sibling group documents that represent the same tournament across tournamentType variants
  const findSiblingGroupDocs = async (groupData) => {
    const siblingsMap = new Map();

    try {
      // 1) If tournamentRoomUid exists, match by tournamentRoomUid + name
      // This ensures we only get variants of THIS SPECIFIC matchday across tournament types
      // NOT all matchdays for this room (which was causing the bug)
      if (groupData.tournamentRoomUid && groupData.name) {
        const qTR = query(
          collection(db, "groups"),
          where("tournamentRoomUid", "==", groupData.tournamentRoomUid),
          where("name", "==", groupData.name)
        );
        const snap = await getDocs(qTR);
        snap.forEach((s) => siblingsMap.set(s.id, s.data()));
      }

      // 2) Match by (league + name + tournament) or (league + name + season)
      const top = groupData.tournament || groupData.season;
      if (top) {
        const qT = query(
          collection(db, "groups"),
          where("league", "==", groupData.league),
          where("name", "==", groupData.name),
          where("tournament", "==", top)
        );
        const snapT = await getDocs(qT);
        snapT.forEach((s) => siblingsMap.set(s.id, s.data()));

        const qS = query(
          collection(db, "groups"),
          where("league", "==", groupData.league),
          where("name", "==", groupData.name),
          where("season", "==", top)
        );
        const snapS = await getDocs(qS);
        snapS.forEach((s) => siblingsMap.set(s.id, s.data()));
      }

      // 3) Fallback: Match by league + sport + name + tournament/season
      // IMPORTANT: Must include tournament/season to avoid matching groups from different tournaments
      if (top) {
        const qF = query(
          collection(db, "groups"),
          where("league", "==", groupData.league),
          where("sport", "==", groupData.sport),
          where("name", "==", groupData.name)
        );
        const snapF = await getDocs(qF);
        snapF.forEach((s) => {
          const sData = s.data();
          // Only include if tournament/season matches
          const norm = (str) => (str || "").toString().trim().toLowerCase();
          const sTournament = norm(sData.tournament || sData.season || "");
          const targetTournament = norm(top);
          if (sTournament === targetTournament) {
            siblingsMap.set(s.id, sData);
          }
        });
      }

      // 4) Final validation: Ensure all results match tournament/season
      // This prevents matching groups from different tournaments with the same name
      if (top) {
        const norm = (s) => (s || "").toString().trim().toLowerCase();
        const targetTournament = norm(top);
        const filteredSiblings = new Map();

        siblingsMap.forEach((data, id) => {
          const siblingTournament = norm(data.tournament || data.season || "");
          // STRICT: Only keep if tournament/season EXACTLY matches
          // Do NOT include groups without tournament/season to prevent cross-contamination
          if (siblingTournament && siblingTournament === targetTournament) {
            filteredSiblings.set(id, data);
          }
        });

        return Array.from(filteredSiblings.entries()).map(([id, data]) => ({
          id,
          data,
        }));
      }
    } catch (err) {
      console.error("Error finding sibling groups:", err);
    }

    // Return array of { id, data }
    return Array.from(siblingsMap.entries()).map(([id, data]) => ({
      id,
      data,
    }));
  };

  const [eventToSubmitResult, setEventToSubmitResult] = useState();
  const [eventToSubmitResultResult, setEventToSubmitResultResult] = useState();
  const [submitEventResultModalIsOpen, setSubmitEventResultModalIsOpen] =
    useState(false);
  const toggleSubmitEventResultModal = (event) => {
    if (event) {
      setEventToSubmitResult(event);
    }
    setEventToSubmitResultResult("");
    setSubmitEventResultModalIsOpen(!submitEventResultModalIsOpen);
  };

  const getChallengeWinnerUid = (challenge, result) => {
    let winnerUid = "";

    challenge.bets.forEach((bet) => {
      if (bet.result === result) {
        winnerUid = bet.bettorUid;
      }
    });

    return winnerUid;
  };

  // helper to safely compare team names (makes matching resilient to casing/whitespace)
  const normalizeTeam = (s) => (s || "").toString().trim().toLowerCase();

  const submitEventResult = async () => {
    // Declare userCache at function scope so it's available to processPendingChallengesForEvent
    let userCache = new Map();

    try {
      setIsLoading(true);

      // Find sibling group documents
      const q = query(collection(db, "groups"), where("uid", "==", group.uid));
      const findGroups = await getDocs(q);
      const primaryGroupSnap = findGroups.docs[0];
      const primaryGroupData = primaryGroupSnap.data();

      const siblingDocs = await findSiblingGroupDocs(primaryGroupData);

      // Apply the event result to all sibling documents using batch
      const groupBatch = writeBatch(db);
      let updatedPrimaryGroupData = { ...primaryGroupData };
      siblingDocs.forEach((sibling) => {
        const groupData = sibling.data;
        let eventsLocal = groupData.events || [];
        eventsLocal.forEach((event) => {
          if (
            normalizeTeam(event.homeTeam) ===
              normalizeTeam(eventToSubmitResult.homeTeam) &&
            normalizeTeam(event.awayTeam) ===
              normalizeTeam(eventToSubmitResult.awayTeam)
          ) {
            event.result = eventToSubmitResultResult;
          }
        });
        const groupRef = doc(db, "groups", sibling.id);
        groupBatch.update(groupRef, { events: eventsLocal });

        // Update the primary group data with the new events
        if (sibling.id === primaryGroupSnap.id) {
          updatedPrimaryGroupData.events = eventsLocal;
        }
      });
      await groupBatch.commit();

      console.log(
        `✓ Event result "${eventToSubmitResultResult}" submitted for ${eventToSubmitResult.homeTeam} vs ${eventToSubmitResult.awayTeam}`
      );

      // Always check if all results are in (the function itself handles idempotency)
      console.log(
        `Checking if all results are in for "${updatedPrimaryGroupData.name}"...`
      );
      await checkIfAllResultsAreInAndNotify(updatedPrimaryGroupData);

      // Run point assignment only once using the resultsAppliedAt marker
      const appliedMarker = primaryGroupData.resultsAppliedAt;
      if (!appliedMarker) {
        // ASSIGN POINTS - Optimized with batch writes and user caching
        const q1 = query(
          collection(db, "rooms"),
          where("leagueName", "==", primaryGroupData.league)
        );
        const findRooms = await getDocs(q1);

        // Collect all unique user UIDs across all rooms/submissions
        const allUserUids = new Set();
        const roomsDataArray = [];
        findRooms.docs.forEach((roomDoc) => {
          const roomData = roomDoc.data();
          roomsDataArray.push({ id: roomDoc.id, data: roomData });
          roomData.submissions?.forEach((submission) => {
            if (submission.submitterUid)
              allUserUids.add(submission.submitterUid);
          });
          // Also collect challenge participant UIDs
          roomData.challenges?.forEach((challenge) => {
            challenge.bets?.forEach((bet) => {
              if (bet.bettorUid) allUserUids.add(bet.bettorUid);
            });
            if (challenge.submitterUid) allUserUids.add(challenge.submitterUid);
            if (challenge.challengerUid)
              allUserUids.add(challenge.challengerUid);
          });
        });

        // Fetch all users in parallel (batch query) - reuse the userCache from outer scope
        if (allUserUids.size > 0) {
          const userUidsArray = Array.from(allUserUids);
          const chunkSize = 10; // Firestore 'in' query limit
          const userQueries = [];
          for (let i = 0; i < userUidsArray.length; i += chunkSize) {
            const chunk = userUidsArray.slice(i, i + chunkSize);
            const qUsers = query(
              collection(db, "users"),
              where("uid", "in", chunk)
            );
            userQueries.push(getDocs(qUsers));
          }
          const userSnapshots = await Promise.all(userQueries);
          userSnapshots.forEach((snapshot) => {
            snapshot.docs.forEach((userDoc) => {
              const userData = userDoc.data();
              if (userData.uid) {
                userCache.set(userData.uid, {
                  docId: userDoc.id,
                  data: userData,
                });
              }
            });
          });
        }

        // Prepare batch writes for users and rooms
        let userBatch = writeBatch(db);
        let roomBatch = writeBatch(db);
        let notificationBatch = writeBatch(db);
        const emailPromises = [];
        let userBatchCount = 0;
        let roomBatchCount = 0;
        let notificationBatchCount = 0;
        const MAX_BATCH_SIZE = 500; // Firestore batch write limit

        for (const roomObj of roomsDataArray) {
          const roomData = roomObj.data;
          const submissions = roomData.submissions || [];
          let challenges = roomData.challenges || [];
          let newRoomMembers = roomData.members || [];
          let challengeNotificationsSent = new Set(); // Track sent notifications per room

          for (const submission of submissions) {
            // Skip submissions that don't match this group (across all tournament type variants)
            const submissionMatchesGroup =
              submission.groupUid === primaryGroupData.uid ||
              siblingDocs.some((s) => s.data.uid === submission.groupUid);

            if (!submissionMatchesGroup) continue;

            let tickets = 0;
            let starPoints = 0;
            let challengeStarCoins = 0;

            const eventSubmission = submission.events.filter((event) => {
              return (
                normalizeTeam(event.homeTeam) ===
                  normalizeTeam(eventToSubmitResult.homeTeam) &&
                normalizeTeam(event.awayTeam) ===
                  normalizeTeam(eventToSubmitResult.awayTeam)
              );
            });

            if (
              eventSubmission[0]?.selectedResult === eventToSubmitResultResult
            ) {
              if (eventSubmission[0].isStarGame) {
                if (
                  roomData.leagueName === "NBA" ||
                  roomData.leagueName === "MLB" ||
                  roomData.leagueName === "NHL"
                ) {
                  starPoints += 1;
                } else if (
                  roomData.leagueName === "NFL" ||
                  roomData.leagueName === "UFL"
                ) {
                  starPoints += 4;
                } else {
                  starPoints += 6;
                }
              } else {
                if (
                  roomData.leagueName === "NBA" ||
                  roomData.leagueName === "MLB" ||
                  roomData.leagueName === "NHL"
                ) {
                  tickets += 0.25;
                } else if (
                  roomData.leagueName === "NFL" ||
                  roomData.leagueName === "UFL"
                ) {
                  tickets += 2;
                } else {
                  tickets += 3;
                }
              }
            } else if (
              eventToSubmitResultResult === "Draw" &&
              (eventSubmission[0]?.selectedResult === "Home" ||
                eventSubmission[0]?.selectedResult === "Away")
            ) {
              if (eventSubmission[0].isStarGame) {
                starPoints += 2;
              } else {
                tickets += 1;
              }
            }

            newRoomMembers.forEach((member) => {
              if (!member.starPoints) {
                member.starPoints = 0;
              }
              if (member.uid === submission.submitterUid) {
                member.points += tickets;
                member.starPoints += starPoints;
              }
            });

            // Use cached user data instead of querying
            const userCacheEntry = userCache.get(submission.submitterUid);
            if (userCacheEntry) {
              const userData = userCacheEntry.data;
              const userDocId = userCacheEntry.docId;

              for (const challenge of challenges || []) {
                if (
                  normalizeTeam(challenge.event.homeTeam) ===
                    normalizeTeam(eventToSubmitResult.homeTeam) &&
                  normalizeTeam(challenge.event.awayTeam) ===
                    normalizeTeam(eventToSubmitResult.awayTeam)
                ) {
                  if (challenge.challengerUid) {
                    challenge.isCompleted = true;
                    challenge.winnerUid = getChallengeWinnerUid(
                      challenge,
                      eventToSubmitResultResult
                    );

                    for (const bet of challenge.bets) {
                      // Only send notification once per bettor
                      if (!challengeNotificationsSent.has(bet.bettorUid)) {
                        challengeNotificationsSent.add(bet.bettorUid);

                        const newNotificationData = {
                          uid: uuidv4(),
                          title: "Challenge results are in!",
                          description: `The results for your challenge in ${league}'s ${groupName} are in!`,
                          recipientUid: bet.bettorUid,
                          dateCreated: new Date().toISOString(),
                          isRead: false,
                        };

                        // Add to batch
                        if (notificationBatchCount < MAX_BATCH_SIZE) {
                          const notifRef = doc(collection(db, "notifications"));
                          notificationBatch.set(notifRef, newNotificationData);
                          notificationBatchCount++;
                        } else {
                          // Commit current batch and start new one
                          await notificationBatch.commit();
                          notificationBatch = writeBatch(db);
                          const notifRef = doc(collection(db, "notifications"));
                          notificationBatch.set(notifRef, newNotificationData);
                          notificationBatchCount = 1;
                        }

                        // Send email (fire-and-forget)
                        const bettorData = userCache.get(bet.bettorUid)?.data;
                        if (bettorData) {
                          const serviceId = "sportleague_outlook";
                          const templateId = "challengeBettor";
                          const publicKey = "Ki5BETKiWrS6RDEP_";
                          const templateParams = {
                            bettorUsername: bet.bettorName,
                            bettorEmail: bettorData.email,
                            leagueName: league,
                            groupName: groupName,
                            linkToRoom: `https://app.sportleague.com/play/leagues/${roomData.leagueUid}/rooms/${roomData.uid}`,
                          };

                          emailPromises.push(
                            emailjs
                              .send(
                                serviceId,
                                templateId,
                                templateParams,
                                publicKey
                              )
                              .catch((e) => console.error("Email failed:", e))
                          );
                        }
                      }

                      if (bet.bettorUid === userData?.uid) {
                        if (bet.result === eventToSubmitResultResult) {
                          challengeStarCoins += parseInt(challenge.prizePool);

                          newRoomMembers.forEach((member) => {
                            if (member.uid === submission.submitterUid) {
                              member.challengesWon += 1;
                            }
                          });
                        }
                      }
                    }
                  } else {
                    // No challenger accepted this challenge: return prize to submitter
                    newRoomMembers.forEach((member) => {
                      if (member.uid === challenge.submitterUid) {
                        member.starCoins += challenge.prizePool;
                      }
                    });
                    challenge.isCompleted = true;
                  }
                }
              }

              let userTickets = userData.tickets || 0;
              let userStarCoins = userData.starCoins || 0;
              let userChampionPoints = userData.championPoints || 0;

              let doesUserHaveAnActiveTicketBoost;
              if (userData.ticketBoostExpirationDatetime) {
                if (
                  userData.ticketBoostExpirationDatetime.toDate() > new Date()
                ) {
                  doesUserHaveAnActiveTicketBoost = true;
                } else {
                  doesUserHaveAnActiveTicketBoost = false;
                }
              } else {
                doesUserHaveAnActiveTicketBoost = false;
              }

              userTickets +=
                tickets * (doesUserHaveAnActiveTicketBoost ? 2 : 1);
              userStarCoins += challengeStarCoins;
              userChampionPoints += tickets;

              // Add to batch instead of immediate update
              if (userBatchCount < MAX_BATCH_SIZE) {
                const userRef = doc(db, "users", userDocId);
                userBatch.update(userRef, {
                  tickets: parseFloat(userTickets),
                  starCoins: parseFloat(userStarCoins),
                  championPoints: parseFloat(userChampionPoints),
                  ticketBoostExpirationDatetime: doesUserHaveAnActiveTicketBoost
                    ? userData.ticketBoostExpirationDatetime
                    : null,
                });
                userBatchCount++;
              } else {
                // Commit current batch and start new one
                await userBatch.commit();
                userBatch = writeBatch(db);
                const userRef = doc(db, "users", userDocId);
                userBatch.update(userRef, {
                  tickets: parseFloat(userTickets),
                  starCoins: parseFloat(userStarCoins),
                  championPoints: parseFloat(userChampionPoints),
                  ticketBoostExpirationDatetime: doesUserHaveAnActiveTicketBoost
                    ? userData.ticketBoostExpirationDatetime
                    : null,
                });
                userBatchCount = 1;
              }

              // Update cache with new values
              userCache.set(submission.submitterUid, {
                docId: userDocId,
                data: {
                  ...userData,
                  tickets: userTickets,
                  starCoins: userStarCoins,
                  championPoints: userChampionPoints,
                },
              });
            }

            newRoomMembers.forEach((member) => {
              if (member.uid === submission.submitterUid) {
                member.total = member.points + member.starPoints;
              }
            });
          }

          // Sort members and update room
          newRoomMembers = newRoomMembers.sort((a, b) => {
            return b.total - a.total;
          });
          newRoomMembers.forEach((member) => {
            member.place = newRoomMembers.indexOf(member) + 1;
          });

          // Add room update to batch
          if (roomBatchCount < MAX_BATCH_SIZE) {
            const roomRef = doc(db, "rooms", roomObj.id);
            roomBatch.update(roomRef, {
              members: newRoomMembers,
              challenges: challenges,
            });
            roomBatchCount++;
          } else {
            // Commit current batch and start new one
            await roomBatch.commit();
            roomBatch = writeBatch(db);
            const roomRef = doc(db, "rooms", roomObj.id);
            roomBatch.update(roomRef, {
              members: newRoomMembers,
              challenges: challenges,
            });
            roomBatchCount = 1;
          }
        }

        // Commit all remaining batches
        if (userBatchCount > 0) await userBatch.commit();
        if (roomBatchCount > 0) await roomBatch.commit();
        if (notificationBatchCount > 0) await notificationBatch.commit();

        // mark resultsAppliedAt on all siblings using batch
        const appliedAt = new Date().toISOString();
        const siblingBatch = writeBatch(db);
        siblingDocs.forEach((sibling) => {
          const ref = doc(db, "groups", sibling.id);
          siblingBatch.update(ref, { resultsAppliedAt: appliedAt });
        });
        await siblingBatch.commit();
      }

      // Fallback: if for some reason some challenges were not processed when results were applied,
      // scan rooms and close any matching challenges that are still open. This ensures accepted
      // challenges get marked completed, winners set, notifications sent, and prizes applied.
      const processPendingChallengesForEvent = async () => {
        try {
          const qRooms = query(
            collection(db, "rooms"),
            where("leagueName", "==", primaryGroupData.league)
          );
          const findRooms = await getDocs(qRooms);

          const pendingBatch = writeBatch(db);
          const pendingNotifBatch = writeBatch(db);
          let pendingBatchCount = 0;
          let pendingNotifCount = 0;

          for (const roomObject of findRooms.docs) {
            const roomData = roomObject.data();
            let challenges = roomData.challenges || [];
            let roomUpdated = false;

            for (const challenge of challenges || []) {
              if (
                normalizeTeam(challenge.event?.homeTeam) ===
                  normalizeTeam(eventToSubmitResult.homeTeam) &&
                normalizeTeam(challenge.event?.awayTeam) ===
                  normalizeTeam(eventToSubmitResult.awayTeam) &&
                !challenge.isCompleted
              ) {
                // mark completed and determine winner (if challenger exists)
                if (challenge.challengerUid) {
                  challenge.isCompleted = true;
                  challenge.winnerUid = getChallengeWinnerUid(
                    challenge,
                    eventToSubmitResultResult
                  );

                  // notify all bettors using batch
                  for (const bet of challenge.bets || []) {
                    const newNotificationData = {
                      uid: uuidv4(),
                      title: "Challenge results are in!",
                      description: `The results for your challenge in ${league}'s ${groupName} are in!`,
                      recipientUid: bet.bettorUid,
                      dateCreated: new Date().toISOString(),
                      isRead: false,
                    };

                    const notifRef = doc(collection(db, "notifications"));
                    pendingNotifBatch.set(notifRef, newNotificationData);
                    pendingNotifCount++;

                    // fire-and-forget email (best-effort) - use cached user data
                    const bettorData = userCache.get(bet.bettorUid)?.data;
                    if (bettorData) {
                      (async () => {
                        try {
                          const serviceId = "sportleague_outlook";
                          const templateId = "challengeBettor";
                          const publicKey = "Ki5BETKiWrS6RDEP_";

                          const templateParams = {
                            bettorUsername: bet.bettorName,
                            bettorEmail: bettorData.email,
                            leagueName: league,
                            groupName: groupName,
                            linkToRoom: `https://app.sportleague.com/play/leagues/${roomData.leagueUid}/rooms/${roomData.uid}`,
                          };

                          await emailjs.send(
                            serviceId,
                            templateId,
                            templateParams,
                            publicKey
                          );
                        } catch (e) {
                          console.error("Email send failed (non-blocking)", e);
                        }
                      })();
                    }
                  }

                  // award prize to winner using batch (if determined)
                  if (challenge.winnerUid) {
                    const winnerData = userCache.get(challenge.winnerUid);
                    if (winnerData) {
                      let newStarCoins = winnerData.data.starCoins || 0;
                      newStarCoins += parseInt(challenge.prizePool || 0);
                      const wRef = doc(db, "users", winnerData.docId);
                      pendingBatch.update(wRef, { starCoins: newStarCoins });
                      pendingBatchCount++;
                    }
                  }
                } else {
                  // No challenger: return prize to submitter and mark completed
                  challenge.isCompleted = true;
                  const submitterData = userCache.get(challenge.submitterUid);
                  if (submitterData) {
                    let newStarCoins = submitterData.data.starCoins || 0;
                    newStarCoins += parseInt(challenge.prizePool || 0);
                    const sRef = doc(db, "users", submitterData.docId);
                    pendingBatch.update(sRef, { starCoins: newStarCoins });
                    pendingBatchCount++;
                  }
                }

                roomUpdated = true;
              }
            }

            if (roomUpdated) {
              const roomRef = doc(db, "rooms", roomObject.id);
              pendingBatch.update(roomRef, { challenges: challenges });
              pendingBatchCount++;
            }
          }

          // Commit pending batches
          if (pendingBatchCount > 0) await pendingBatch.commit();
          if (pendingNotifCount > 0) await pendingNotifBatch.commit();
        } catch (err) {
          console.error("Error processing pending challenges:", err);
        }
      };

      // always try to process any pending challenges for this particular event
      await processPendingChallengesForEvent();

      // try to refresh local group state and close UI; ensure loading cleared in all cases
      // Note: don't await here synchronously earlier because we want to guarantee UI unblocks
      // Use finally block to ensure cleanup runs even on unexpected errors
    } catch (err) {
      console.error(err);
      alert("An error occured while submitting event result");
      setIsLoading(false);
    } finally {
      try {
        await fetchGroup();
      } catch (e) {
        console.error("Error refreshing group after submit:", e);
      }
      // ensure modals / edit state are closed and loading cleared
      setSubmitEventResultModalIsOpen(false);
      setEventToSubmitResult(null);
      setEventToSubmitResultResult(null);
      setEditEventModalIsVisible(false);
      setIsLoading(false);
    }
  };

  const revertResult = async () => {
    Swal.fire({
      text: "Are you sure you want to revert this result?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, REVERT",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const eventResultToRevert = eventToEdit.result;

          // Find sibling group documents
          const q = query(
            collection(db, "groups"),
            where("uid", "==", group.uid)
          );
          const findGroups = await getDocs(q);
          const primaryGroupSnap = findGroups.docs[0];
          const primaryGroupData = primaryGroupSnap.data();

          const siblingDocs = await findSiblingGroupDocs(primaryGroupData);

          // Remove the event result from all sibling documents using batch
          const groupBatch = writeBatch(db);
          siblingDocs.forEach((sibling) => {
            const groupData = sibling.data;
            let eventsLocal = groupData.events || [];
            eventsLocal.forEach((event) => {
              if (
                event.homeTeam === eventToEdit.homeTeam &&
                event.awayTeam === eventToEdit.awayTeam
              ) {
                delete event.result;
              }
            });
            const groupRef = doc(db, "groups", sibling.id);
            groupBatch.update(groupRef, { events: eventsLocal });
          });
          await groupBatch.commit();

          // REVERT POINTS - Query rooms in this league
          const q1 = query(
            collection(db, "rooms"),
            where("leagueName", "==", primaryGroupData.league)
          );
          const findRooms = await getDocs(q1);

          // Collect all unique user UIDs across all rooms/submissions
          const allUserUids = new Set();
          const roomsDataArray = [];
          findRooms.docs.forEach((roomDoc) => {
            const roomData = roomDoc.data();
            roomsDataArray.push({ id: roomDoc.id, data: roomData });
            roomData.submissions?.forEach((submission) => {
              if (submission.submitterUid)
                allUserUids.add(submission.submitterUid);
            });
            // Also collect challenge participant UIDs
            roomData.challenges?.forEach((challenge) => {
              challenge.bets?.forEach((bet) => {
                if (bet.bettorUid) allUserUids.add(bet.bettorUid);
              });
              if (challenge.submitterUid)
                allUserUids.add(challenge.submitterUid);
              if (challenge.challengerUid)
                allUserUids.add(challenge.challengerUid);
            });
          });

          // Fetch all users in parallel (batch query)
          const userCache = new Map();
          if (allUserUids.size > 0) {
            const userUidsArray = Array.from(allUserUids);
            const chunkSize = 10; // Firestore 'in' query limit
            const userQueries = [];
            for (let i = 0; i < userUidsArray.length; i += chunkSize) {
              const chunk = userUidsArray.slice(i, i + chunkSize);
              const qUsers = query(
                collection(db, "users"),
                where("uid", "in", chunk)
              );
              userQueries.push(getDocs(qUsers));
            }
            const userSnapshots = await Promise.all(userQueries);
            userSnapshots.forEach((snapshot) => {
              snapshot.docs.forEach((userDoc) => {
                const userData = userDoc.data();
                if (userData.uid) {
                  userCache.set(userData.uid, {
                    docId: userDoc.id,
                    data: userData,
                  });
                }
              });
            });
          }

          // Prepare batch writes for users and rooms
          let userBatch = writeBatch(db);
          let roomBatch = writeBatch(db);
          let userBatchCount = 0;
          let roomBatchCount = 0;
          const MAX_BATCH_SIZE = 500;

          for (const roomObj of roomsDataArray) {
            const roomData = roomObj.data;
            const submissions = roomData.submissions || [];
            let challenges = roomData.challenges || [];
            let newRoomMembers = roomData.members || [];

            for (const submission of submissions) {
              let tickets = 0;
              let starPoints = 0;
              let challengeStarCoins = 0;

              const eventSubmission = submission.events.filter((event) => {
                return (
                  event.homeTeam === eventToEdit.homeTeam &&
                  event.awayTeam === eventToEdit.awayTeam
                );
              });

              // Revert points that were awarded when result was submitted
              if (eventSubmission[0]?.selectedResult === eventResultToRevert) {
                if (eventSubmission[0].isStarGame) {
                  if (
                    roomData.leagueName === "NBA" ||
                    roomData.leagueName === "MLB" ||
                    roomData.leagueName === "NHL"
                  ) {
                    starPoints -= 1;
                  } else if (
                    roomData.leagueName === "NFL" ||
                    roomData.leagueName === "UFL"
                  ) {
                    starPoints -= 4;
                  } else {
                    starPoints -= 6;
                  }
                } else {
                  if (
                    roomData.leagueName === "NBA" ||
                    roomData.leagueName === "MLB" ||
                    roomData.leagueName === "NHL"
                  ) {
                    tickets -= 0.25;
                  } else if (
                    roomData.leagueName === "NFL" ||
                    roomData.leagueName === "UFL"
                  ) {
                    tickets -= 2;
                  } else {
                    tickets -= 3;
                  }
                }
              } else if (
                eventResultToRevert === "Draw" &&
                (eventSubmission[0]?.selectedResult === "Home" ||
                  eventSubmission[0]?.selectedResult === "Away")
              ) {
                if (eventSubmission[0].isStarGame) {
                  starPoints -= 2;
                } else {
                  tickets -= 1;
                }
              }

              // Update room members
              newRoomMembers.forEach((member) => {
                if (!member.starPoints) {
                  member.starPoints = 0;
                }
                if (member.uid === submission.submitterUid) {
                  member.points += tickets;
                  member.starPoints += starPoints;
                }
              });

              // Use cached user data
              const userCacheEntry = userCache.get(submission.submitterUid);
              if (userCacheEntry) {
                const userData = userCacheEntry.data;
                const userDocId = userCacheEntry.docId;

                // Revert challenge winnings if applicable
                for (const challenge of challenges || []) {
                  if (
                    normalizeTeam(challenge.event.homeTeam) ===
                      normalizeTeam(eventToEdit.homeTeam) &&
                    normalizeTeam(challenge.event.awayTeam) ===
                      normalizeTeam(eventToEdit.awayTeam) &&
                    challenge.isCompleted
                  ) {
                    // Revert the challenge to uncompleted state
                    challenge.isCompleted = false;
                    delete challenge.winnerUid;

                    for (const bet of challenge.bets) {
                      if (bet.bettorUid === userData?.uid) {
                        if (bet.result === eventResultToRevert) {
                          // Revert the prize pool that was awarded
                          challengeStarCoins -= parseInt(challenge.prizePool);

                          newRoomMembers.forEach((member) => {
                            if (member.uid === submission.submitterUid) {
                              if (member.challengesWon > 0) {
                                member.challengesWon -= 1;
                              }
                            }
                          });
                        }
                      }
                    }
                  }
                }

                let userTickets = userData.tickets || 0;
                let userStarCoins = userData.starCoins || 0;
                let userChampionPoints = userData.championPoints || 0;

                // Check if user had active ticket boost when result was submitted
                let doesUserHaveAnActiveTicketBoost;
                if (userData.ticketBoostExpirationDatetime) {
                  if (
                    userData.ticketBoostExpirationDatetime.toDate() > new Date()
                  ) {
                    doesUserHaveAnActiveTicketBoost = true;
                  } else {
                    doesUserHaveAnActiveTicketBoost = false;
                  }
                } else {
                  doesUserHaveAnActiveTicketBoost = false;
                }

                // Revert the tickets/coins that were awarded
                userTickets +=
                  tickets * (doesUserHaveAnActiveTicketBoost ? 2 : 1);
                userStarCoins += challengeStarCoins;
                userChampionPoints += tickets;

                // Add to batch
                if (userBatchCount < MAX_BATCH_SIZE) {
                  const userRef = doc(db, "users", userDocId);
                  userBatch.update(userRef, {
                    tickets: parseFloat(userTickets),
                    starCoins: parseFloat(userStarCoins),
                    championPoints: parseFloat(userChampionPoints),
                  });
                  userBatchCount++;
                } else {
                  await userBatch.commit();
                  userBatch = writeBatch(db);
                  const userRef = doc(db, "users", userDocId);
                  userBatch.update(userRef, {
                    tickets: parseFloat(userTickets),
                    starCoins: parseFloat(userStarCoins),
                    championPoints: parseFloat(userChampionPoints),
                  });
                  userBatchCount = 1;
                }

                // Update cache
                userCache.set(submission.submitterUid, {
                  docId: userDocId,
                  data: {
                    ...userData,
                    tickets: userTickets,
                    starCoins: userStarCoins,
                    championPoints: userChampionPoints,
                  },
                });
              }

              newRoomMembers.forEach((member) => {
                if (member.uid === submission.submitterUid) {
                  member.total = member.points + member.starPoints;
                }
              });
            }

            // Sort members and update room
            newRoomMembers = newRoomMembers.sort((a, b) => {
              return b.total - a.total;
            });
            newRoomMembers.forEach((member) => {
              member.place = newRoomMembers.indexOf(member) + 1;
            });

            // Add room update to batch
            if (roomBatchCount < MAX_BATCH_SIZE) {
              const roomRef = doc(db, "rooms", roomObj.id);
              roomBatch.update(roomRef, {
                members: newRoomMembers,
                challenges: challenges,
              });
              roomBatchCount++;
            } else {
              await roomBatch.commit();
              roomBatch = writeBatch(db);
              const roomRef = doc(db, "rooms", roomObj.id);
              roomBatch.update(roomRef, {
                members: newRoomMembers,
                challenges: challenges,
              });
              roomBatchCount = 1;
            }
          }

          // Commit all remaining batches
          if (userBatchCount > 0) await userBatch.commit();
          if (roomBatchCount > 0) await roomBatch.commit();

          await fetchGroup();

          Swal.fire({
            text: "Result has been reverted successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          setEditEventModalIsVisible(false);
          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while reverting group result");
          setIsLoading(false);
        }
      }
    });
  };

  const [driverForModal, setDriverForModal] = useState();
  const [submitDriverResultModalIsOpen, setSubmitDriverResultModalIsOpen] =
    useState(false);
  const toggleSubmitDriverResultModal = (driver) => {
    if (driver) {
      setDriverForModal(driver);
    }
    setSubmitDriverResultModalIsOpen(!submitDriverResultModalIsOpen);
  };

  const [selectedDriverResult, setSelectedDriverResult] = useState();

  const driverResults = [
    {
      value: "firstPolePosition",
      label: "1st Pole Position",
    },
    {
      value: "secondPolePosition",
      label: "2nd Pole Position",
    },
    {
      value: "thirdPolePosition",
      label: "3rd Pole Position",
    },
    {
      value: "fourthPlace",
      label: "4th Place",
    },
    {
      value: "fifthPlace",
      label: "5th Place",
    },
    {
      value: "sixthPlace",
      label: "6th Place",
    },
    {
      value: "seventhPlace",
      label: "7th Place",
    },
    {
      value: "eighthPlace",
      label: "8th Place",
    },
    {
      value: "ninthPlace",
      label: "9th Place",
    },
    {
      value: "tenthPlace",
      label: "10th Place",
    },
    {
      value: "eleventhPlace",
      label: "11th Place",
    },
    {
      value: "twelfthPlace",
      label: "12th Place",
    },
    {
      value: "thirteenthPlace",
      label: "13th Place",
    },
    {
      value: "fourteenthPlace",
      label: "14th Place",
    },
    {
      value: "fifteenthPlace",
      label: "15th Place",
    },
    {
      value: "sixteenthPlace",
      label: "16th Place",
    },
    {
      value: "seventeenthPlace",
      label: "17th Place",
    },
    {
      value: "eighteenthPlace",
      label: "18th Place",
    },
    {
      value: "nineteenthPlace",
      label: "19th Place",
    },
    {
      value: "twentiethPlace",
      label: "20th Place",
    },
  ];

  const submitDriverResult = async () => {
    try {
      setIsLoading(true);

      // find primary group and siblings
      const q = query(collection(db, "groups"), where("uid", "==", group.uid));
      const findGroups = await getDocs(q);
      const primaryGroupData = findGroups.docs[0].data();
      const siblingDocs = await findSiblingGroupDocs(primaryGroupData);

      // Update all siblings using batch
      const groupBatch = writeBatch(db);
      siblingDocs.forEach((sibling) => {
        const groupData = sibling.data;
        let driversLocal = groupData.drivers || [];
        driversLocal.forEach((driver) => {
          if (driver.name === driverForModal.name) {
            driver.result = selectedDriverResult;
          }
        });
        const groupRef = doc(db, "groups", sibling.id);
        groupBatch.update(groupRef, { drivers: driversLocal });
      });
      await groupBatch.commit();

      // run notifications/assignment once if not already applied
      if (!primaryGroupData.resultsAppliedAt) {
        await checkIfAllResultsAreInAndNotify(primaryGroupData);

        const q1 = query(
          collection(db, "rooms"),
          where("leagueName", "==", primaryGroupData.league)
        );
        const findRooms = await getDocs(q1);

        // Collect all unique user UIDs
        const allUserUids = new Set();
        const roomsDataArray = [];
        findRooms.docs.forEach((roomDoc) => {
          const roomData = roomDoc.data();
          roomsDataArray.push({ id: roomDoc.id, data: roomData });
          roomData.submissions?.forEach((submission) => {
            if (submission.submitterUid)
              allUserUids.add(submission.submitterUid);
          });
        });

        // Fetch all users in parallel
        const userCache = new Map();
        if (allUserUids.size > 0) {
          const userUidsArray = Array.from(allUserUids);
          const chunkSize = 10;
          const userQueries = [];
          for (let i = 0; i < userUidsArray.length; i += chunkSize) {
            const chunk = userUidsArray.slice(i, i + chunkSize);
            const qUsers = query(
              collection(db, "users"),
              where("uid", "in", chunk)
            );
            userQueries.push(getDocs(qUsers));
          }
          const userSnapshots = await Promise.all(userQueries);
          userSnapshots.forEach((snapshot) => {
            snapshot.docs.forEach((userDoc) => {
              const userData = userDoc.data();
              if (userData.uid) {
                userCache.set(userData.uid, {
                  docId: userDoc.id,
                  data: userData,
                });
              }
            });
          });
        }

        // Prepare batches
        const userBatch = writeBatch(db);
        const roomBatch = writeBatch(db);
        let userBatchCount = 0;
        let roomBatchCount = 0;
        const MAX_BATCH_SIZE = 500;

        for (const roomObj of roomsDataArray) {
          const roomData = roomObj.data;
          const submissions = roomData.submissions || [];
          let newRoomMembers = roomData.members || [];

          for (const submission of submissions) {
            let tickets = 0;
            let starPoints = 0;

            const driver = driverForModal?.name;

            if (
              selectedDriverResult === "firstPolePosition" ||
              selectedDriverResult === "secondPolePosition" ||
              selectedDriverResult === "thirdPolePosition"
            ) {
              if (
                submission?.positions?.firstPolePositionDriver === driver ||
                submission?.positions?.secondPolePositionDriver === driver ||
                submission?.positions?.thirdPolePositionDriver === driver
              ) {
                starPoints += 2;
              }
            } else if (
              selectedDriverResult === "fourthPlace" ||
              selectedDriverResult === "fifthPlace" ||
              selectedDriverResult === "sixthPlace" ||
              selectedDriverResult === "seventhPlace" ||
              selectedDriverResult === "eighthPlace"
            ) {
              if (
                submission?.positions?.fourthPlaceDriver === driver ||
                submission?.positions?.fifthPlaceDriver === driver ||
                submission?.positions?.sixthPlaceDriver === driver ||
                submission?.positions?.seventhPlaceDriver === driver ||
                submission?.positions?.eighthPlaceDriver === driver
              ) {
                tickets += 1;
              }
            }

            newRoomMembers.forEach((member) => {
              if (!member.starPoints) member.starPoints = 0;
              if (member.uid === submission.submitterUid) {
                member.points += tickets;
                member.starPoints += starPoints;
              }
            });

            // Use cached user data
            const userCacheEntry = userCache.get(submission.submitterUid);
            if (userCacheEntry) {
              const userData = userCacheEntry.data;
              const userDocId = userCacheEntry.docId;

              let userTickets = userData.tickets || 0;
              let doesUserHaveAnActiveTicketBoost = false;
              if (userData.ticketBoostExpirationDatetime) {
                doesUserHaveAnActiveTicketBoost =
                  userData.ticketBoostExpirationDatetime.toDate() > new Date();
              }

              userTickets +=
                tickets * (doesUserHaveAnActiveTicketBoost ? 2 : 1);

              // Add to batch
              if (userBatchCount < MAX_BATCH_SIZE) {
                const userRef = doc(db, "users", userDocId);
                userBatch.update(userRef, {
                  tickets: parseFloat(userTickets),
                  ticketBoostExpirationDatetime: doesUserHaveAnActiveTicketBoost
                    ? userData.ticketBoostExpirationDatetime
                    : null,
                });
                userBatchCount++;
              } else {
                await userBatch.commit();
                const newUserBatch = writeBatch(db);
                const userRef = doc(db, "users", userDocId);
                newUserBatch.update(userRef, {
                  tickets: parseFloat(userTickets),
                  ticketBoostExpirationDatetime: doesUserHaveAnActiveTicketBoost
                    ? userData.ticketBoostExpirationDatetime
                    : null,
                });
                userBatchCount = 1;
              }
            }

            newRoomMembers.forEach((member) => {
              if (member.uid === submission.submitterUid)
                member.total = member.points + member.starPoints;
            });
          }

          // Sort members
          newRoomMembers = newRoomMembers.sort((a, b) => b.total - a.total);
          newRoomMembers.forEach(
            (member) => (member.place = newRoomMembers.indexOf(member) + 1)
          );

          // Add room update to batch
          if (roomBatchCount < MAX_BATCH_SIZE) {
            const roomRef = doc(db, "rooms", roomObj.id);
            roomBatch.update(roomRef, { members: newRoomMembers });
            roomBatchCount++;
          } else {
            await roomBatch.commit();
            const newRoomBatch = writeBatch(db);
            const roomRef = doc(db, "rooms", roomObj.id);
            newRoomBatch.update(roomRef, { members: newRoomMembers });
            roomBatchCount = 1;
          }
        }

        // Commit all remaining batches
        if (userBatchCount > 0) await userBatch.commit();
        if (roomBatchCount > 0) await roomBatch.commit();

        // Mark resultsAppliedAt on all siblings using batch
        const appliedAt = new Date().toISOString();
        const siblingBatch = writeBatch(db);
        siblingDocs.forEach((sibling) => {
          const ref = doc(db, "groups", sibling.id);
          siblingBatch.update(ref, { resultsAppliedAt: appliedAt });
        });
        await siblingBatch.commit();
      }

      fetchGroup();
      setSelectedDriverResult();
      toggleSubmitDriverResultModal();
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while submitting driver result");
      setIsLoading(false);
    }
  };

  const [fastestLapDriver, setFastestLapDriver] = useState();
  const [submitFastestLapModalIsOpen, setSubmitFastestLapModalIsOpen] =
    useState(false);
  const toggleSubmitFastestLapModal = () => {
    setSubmitFastestLapModalIsOpen(!submitFastestLapModalIsOpen);
  };

  const submitFastestLap = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "groups"), where("uid", "==", group.uid));
      const findGroups = await getDocs(q);
      const primaryGroupData = findGroups.docs[0].data();
      const siblingDocs = await findSiblingGroupDocs(primaryGroupData);

      // Update all siblings using batch
      const groupBatch = writeBatch(db);
      siblingDocs.forEach((sibling) => {
        const groupRef = doc(db, "groups", sibling.id);
        groupBatch.update(groupRef, { fastestLap: fastestLapDriver });
      });
      await groupBatch.commit();

      if (!primaryGroupData.resultsAppliedAt) {
        await checkIfAllResultsAreInAndNotify(primaryGroupData);

        const q1 = query(
          collection(db, "rooms"),
          where("leagueName", "==", primaryGroupData.league)
        );
        const findRooms = await getDocs(q1);

        // Collect all unique user UIDs
        const allUserUids = new Set();
        const roomsDataArray = [];
        findRooms.docs.forEach((roomDoc) => {
          const roomData = roomDoc.data();
          roomsDataArray.push({ id: roomDoc.id, data: roomData });
          roomData.submissions?.forEach((submission) => {
            if (submission.submitterUid)
              allUserUids.add(submission.submitterUid);
          });
        });

        // Fetch all users in parallel
        const userCache = new Map();
        if (allUserUids.size > 0) {
          const userUidsArray = Array.from(allUserUids);
          const chunkSize = 10;
          const userQueries = [];
          for (let i = 0; i < userUidsArray.length; i += chunkSize) {
            const chunk = userUidsArray.slice(i, i + chunkSize);
            const qUsers = query(
              collection(db, "users"),
              where("uid", "in", chunk)
            );
            userQueries.push(getDocs(qUsers));
          }
          const userSnapshots = await Promise.all(userQueries);
          userSnapshots.forEach((snapshot) => {
            snapshot.docs.forEach((userDoc) => {
              const userData = userDoc.data();
              if (userData.uid) {
                userCache.set(userData.uid, {
                  docId: userDoc.id,
                  data: userData,
                });
              }
            });
          });
        }

        // Prepare batches
        const userBatch = writeBatch(db);
        const roomBatch = writeBatch(db);
        let userBatchCount = 0;
        let roomBatchCount = 0;
        const MAX_BATCH_SIZE = 500;

        for (const roomObj of roomsDataArray) {
          const roomData = roomObj.data;
          const submissions = roomData.submissions || [];
          let newRoomMembers = roomData.members || [];

          for (const submission of submissions) {
            let tickets = 0;

            if (submission.positions.fastestLapDriver === fastestLapDriver) {
              tickets += 1;
            }

            newRoomMembers.forEach((member) => {
              if (member.uid === submission.submitterUid) {
                member.points += tickets;
              }
            });

            // Use cached user data
            const userCacheEntry = userCache.get(submission.submitterUid);
            if (userCacheEntry) {
              const userData = userCacheEntry.data;
              const userDocId = userCacheEntry.docId;

              let userTickets = userData.tickets || 0;
              let doesUserHaveAnActiveTicketBoost = false;
              if (userData.ticketBoostExpirationDatetime) {
                doesUserHaveAnActiveTicketBoost =
                  userData.ticketBoostExpirationDatetime.toDate() > new Date();
              }

              userTickets +=
                tickets * (doesUserHaveAnActiveTicketBoost ? 2 : 1);

              // Add to batch
              if (userBatchCount < MAX_BATCH_SIZE) {
                const userRef = doc(db, "users", userDocId);
                userBatch.update(userRef, {
                  tickets: parseFloat(userTickets),
                  ticketBoostExpirationDatetime: doesUserHaveAnActiveTicketBoost
                    ? userData.ticketBoostExpirationDatetime
                    : null,
                });
                userBatchCount++;
              } else {
                await userBatch.commit();
                const newUserBatch = writeBatch(db);
                const userRef = doc(db, "users", userDocId);
                newUserBatch.update(userRef, {
                  tickets: parseFloat(userTickets),
                  ticketBoostExpirationDatetime: doesUserHaveAnActiveTicketBoost
                    ? userData.ticketBoostExpirationDatetime
                    : null,
                });
                userBatchCount = 1;
              }
            }

            newRoomMembers.forEach((member) => {
              if (member.uid === submission.submitterUid) {
                member.total = member.points + member.starPoints;
              }
            });
          }

          // Sort members
          newRoomMembers = newRoomMembers.sort((a, b) => b.total - a.total);
          newRoomMembers.forEach((member, index) => {
            member.place = index + 1;
          });

          // Add room update to batch
          if (roomBatchCount < MAX_BATCH_SIZE) {
            const roomRef = doc(db, "rooms", roomObj.id);
            roomBatch.update(roomRef, { members: newRoomMembers });
            roomBatchCount++;
          } else {
            await roomBatch.commit();
            const newRoomBatch = writeBatch(db);
            const roomRef = doc(db, "rooms", roomObj.id);
            newRoomBatch.update(roomRef, { members: newRoomMembers });
            roomBatchCount = 1;
          }
        }

        // Commit all remaining batches
        if (userBatchCount > 0) await userBatch.commit();
        if (roomBatchCount > 0) await roomBatch.commit();

        // Mark resultsAppliedAt on all siblings using batch
        const appliedAt = new Date().toISOString();
        const siblingBatch = writeBatch(db);
        siblingDocs.forEach((sibling) => {
          const ref = doc(db, "groups", sibling.id);
          siblingBatch.update(ref, { resultsAppliedAt: appliedAt });
        });
        await siblingBatch.commit();
      }

      fetchGroup();
      setFastestLapDriver();
      toggleSubmitFastestLapModal();
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while submitting fastest lap");
      setIsLoading(false);
    }
  };

  const [driverForResultModal, setDriverForResultModal] = useState();
  const [driverResultModalIsOpen, setDriverResultModalIsOpen] = useState();
  const toggleDriverResultModal = (driver) => {
    if (driver) {
      setDriverForResultModal(driver);
    }
    setDriverResultModalIsOpen(!driverResultModalIsOpen);
  };

  const getDriverPosition = (result) => {
    let position = "";

    switch (result) {
      case "firstPolePosition":
        position = "1st";
        break;
      case "secondPolePosition":
        position = "2nd";
        break;
      case "thirdPolePosition":
        position = "3rd";
        break;
      case "fourthPlace":
        position = "4th";
        break;
      case "fifthPlace":
        position = "5th";
        break;
      case "sixthPlace":
        position = "6th";
        break;
      case "seventhPlace":
        position = "7th";
        break;
      case "eighthPlace":
        position = "8th";
        break;
      case "ninthPlace":
        position = "9th";
        break;
      case "tenthPlace":
        position = "10th";
        break;
      case "eleventhPlace":
        position = "11th";
        break;
      case "twelfthPlace":
        position = "12th";
        break;
      case "thirteenthPlace":
        position = "13th";
        break;
      case "fourteenthPlace":
        position = "14th";
        break;
      case "fifteenthPlace":
        position = "15th";
        break;
      case "sixteenthPlace":
        position = "16th";
        break;
      case "seventeenthPlace":
        position = "17th";
        break;
      case "eighteenthPlace":
        position = "18th";
        break;
      case "nineteenthPlace":
        position = "19th";
        break;
      case "twentiethPlace":
        position = "20th";
        break;
      default:
        position = "";
        break;
    }

    return position;
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        GROUP
      </h1>
      <div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Name
        </p>
        <input
          type="text"
          className="mainInput"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          placeholder="The group's username"
          style={{ marginBottom: "0.5rem" }}
          // disabled={new Date(group?.openingDateTime) < new Date()}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Sport
        </p>
        <Input
          type="select"
          className="mainInput"
          value={sport}
          onChange={(e) => setSport(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
          disabled={new Date(group?.openingDateTime) < new Date()}
        >
          <option value="" disabled>
            The event's sport
          </option>
          {sports.map((sport) => {
            return (
              <option key={sport} value={sport}>
                {sport}
              </option>
            );
          })}
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          League
        </p>
        <Input
          type="select"
          className="mainInput"
          value={league}
          onChange={(e) => setLeague(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
          disabled={!sport || new Date(group?.openingDateTime) < new Date()}
        >
          <option value="" disabled>
            The event's league
          </option>
          {/* {
						leagues.map((league) => {
							return (
								<>
									{
										league.sport === sport && league.leagues.map((league) => {
											return (
												<option value={league}>{league}</option>
											)
										})
									}
								</>
							)
						})
					} */}
          {
            // eslint-disable-next-line
            leagues?.map((league) => {
              if (league?.sportCategory === sport?.toUpperCase()) {
                return (
                  <option key={league?.name} value={league?.name}>
                    {league?.name}
                  </option>
                );
              }
            })
          }
        </Input>
        {/* Phase removed */}
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Tournament
        </p>
        <Input
          type="text"
          className="mainInput"
          value={season}
          onChange={(e) => setSeason(e.target.value)}
          placeholder="The tournament's season/name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Opening date & time
        </p>
        <Input
          type="datetime-local"
          className="mainInput"
          value={openingDateTime}
          onChange={(e) => setOpeningDateTime(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
          // disabled={new Date(group?.openingDateTime) < new Date()}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Closing date & time
        </p>
        <Input
          type="datetime-local"
          className="mainInput"
          value={closingDateTime}
          onChange={(e) => setClosingDateTime(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
          // disabled={new Date(group?.openingDateTime) < new Date()}
        />
        {sport === "Racing" ? (
          <>
            <p className="inputLabel" style={{ textAlign: "left" }}>
              Driver(s)
            </p>
            {/* <a href='/admin/leagues/20'>
								<Button className='primaryBtn' style={{marginBottom: '0.5rem'}}>
          				EDIT DRIVERS
        				</Button>
							</a> */}
            {group?.drivers?.map((driver) => {
              return (
                <Button
                  key={driver.name}
                  onClick={
                    driver?.result
                      ? () => toggleDriverResultModal(driver)
                      : () => toggleSubmitDriverResultModal(driver)
                  }
                  className="secondaryBtn"
                  style={{
                    marginBottom: "0.5rem",
                    boxShadow: driver.result
                      ? "0px 0px 0px 3px #FABB00 inset"
                      : "0px 0px 0px 3px #005EE1 inset",
                  }}
                >
                  <span className="driverPosition">
                    {getDriverPosition(driver.result)}
                  </span>
                  {(driver.result === "firstPolePosition" ||
                    driver.result === "secondPolePosition" ||
                    driver.result === "thirdPolePosition") &&
                    "⭐️ "}
                  {driver.name}
                  {(driver.result === "firstPolePosition" ||
                    driver.result === "secondPolePosition" ||
                    driver.result === "thirdPolePosition") &&
                    " ⭐️"}
                </Button>
              );
            })}
            <Modal
              id="submitDriverResultModal"
              isOpen={submitDriverResultModalIsOpen}
              toggle={() => toggleSubmitDriverResultModal(null)}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose
                    onClick={() => toggleSubmitDriverResultModal(null)}
                  />
                </div>
                <div>
                  <h1>SUBMIT RESULT</h1>
                  <div style={{ marginTop: "1rem" }}>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      {driverForModal?.name}
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={selectedDriverResult || ""}
                      onChange={(e) => setSelectedDriverResult(e.target.value)}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <option value="">The driver's position</option>
                      {driverResults.map((result) => {
                        if (
                          group.drivers.filter(
                            (driver) => driver.result === result.value
                          ).length === 0
                        ) {
                          return (
                            <option key={result.value} value={result.value}>
                              {result.label}
                            </option>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </Input>
                    <Button
                      onClick={() => submitDriverResult()}
                      className="primaryBtn"
                      style={{ marginTop: "0.5rem" }}
                      disabled={!selectedDriverResult}
                    >
                      SUBMIT RESULT
                    </Button>
                  </div>
                </div>
              </ModalBody>
            </Modal>
            <Modal
              id="driverResultModal"
              isOpen={driverResultModalIsOpen}
              toggle={() => toggleDriverResultModal(null)}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={() => toggleDriverResultModal(null)} />
                </div>
                <div>
                  <h1>DRIVER RESULT</h1>
                  <div style={{ marginTop: "1rem" }}>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      {driverForResultModal?.name}
                    </p>
                    {driverForResultModal?.result ? (
                      <>
                        <div className="eventYouVotedForContainer">
                          <p
                            style={{
                              color: "#FABB00",
                              fontWeight: 500,
                              marginBottom: 0,
                            }}
                          >
                            Result:{" "}
                            {getDriverPosition(driverForResultModal?.result)}
                          </p>
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              </ModalBody>
            </Modal>
            <p className="inputLabel" style={{ textAlign: "left" }}>
              Fastest lap
            </p>
            <Button
              onClick={() => toggleSubmitFastestLapModal()}
              className="secondaryBtn"
              style={{
                marginBottom: "0.5rem",
                boxShadow: group?.fastestLap
                  ? "0px 0px 0px 3px #FABB00 inset"
                  : "0px 0px 0px 3px #005EE1 inset",
              }}
            >
              {group?.fastestLap ? group?.fastestLap : "SUBMIT FASTEST LAP"}
            </Button>
            <Modal
              id="submitFastestLapModal"
              isOpen={submitFastestLapModalIsOpen}
              toggle={() => toggleSubmitFastestLapModal()}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={() => toggleSubmitFastestLapModal()} />
                </div>
                <div>
                  <h1>SUBMIT FASTEST LAP</h1>
                  <div style={{ marginTop: "1rem" }}>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      {group?.fastestLapDriver?.name}
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={fastestLapDriver}
                      onChange={(e) => setFastestLapDriver(e.target.value)}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <option value="" disabled>
                        The driver with the fastest lap
                      </option>
                      {group?.drivers.map((driver) => {
                        return (
                          <option key={driver.name} value={driver.name}>
                            {driver.name}
                          </option>
                        );
                      })}
                    </Input>
                    <Button
                      onClick={() => submitFastestLap()}
                      className="primaryBtn"
                      style={{ marginTop: "0.5rem" }}
                      disabled={
                        group?.fastestLap
                          ? !!group?.fastestLap
                          : !fastestLapDriver
                      }
                    >
                      SUBMIT FASTEST LAP
                    </Button>
                  </div>
                </div>
              </ModalBody>
            </Modal>
          </>
        ) : (
          <>
            <p className="inputLabel" style={{ textAlign: "left" }}>
              Event(s)
            </p>
            {
              // new Date(group?.openingDateTime) > new Date() &&
              <Button
                onClick={toggleCreateEventModal}
                className="primaryBtn"
                style={{ marginBottom: "0.5rem" }}
                disabled={!sport || !league}
              >
                CREATE EVENT
              </Button>
            }
            <Modal
              id="serviceSelectModal"
              isOpen={createEventModalIsVisible}
              toggle={toggleCreateEventModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleCreateEventModal} />
                </div>
                <div>
                  <h1>CREATE EVENT</h1>
                  <div style={{ marginTop: "1rem" }}>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Home team
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={homeTeam}
                      onChange={(e) => setHomeTeam(e.target.value)}
                      style={{ marginBottom: "0.5rem" }}
                      disabled={!league}
                    >
                      <option value="" disabled>
                        The event's home team
                      </option>
                      {
                        // eslint-disable-next-line
                        teams?.map((team) => {
                          if (team.league === league) {
                            return (
                              <option
                                key={team.name}
                                value={team.name}
                                disabled={
                                  team.name === awayTeam ||
                                  (team.league !== "NBA" &&
                                    team.league !== "MLB" &&
                                    team.league !== "NHL" &&
                                    teamsTaken.includes(team.name))
                                }
                              >
                                {team.name}
                              </option>
                            );
                          }
                        })
                      }
                    </Input>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Away team
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={awayTeam}
                      onChange={(e) => setAwayTeam(e.target.value)}
                      style={{ marginBottom: "0.5rem" }}
                      disabled={!league}
                    >
                      <option value="" disabled>
                        The event's away team
                      </option>
                      {
                        // eslint-disable-next-line
                        teams?.map((team) => {
                          if (team.league === league) {
                            return (
                              <option
                                key={team.name}
                                value={team.name}
                                disabled={
                                  team.name === homeTeam ||
                                  (team.league !== "NBA" &&
                                    team.league !== "MLB" &&
                                    team.league !== "NHL" &&
                                    teamsTaken.includes(team.name))
                                }
                              >
                                {team.name}
                              </option>
                            );
                          }
                        })
                      }
                    </Input>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Star game
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={eventIsStarGame}
                      onChange={(e) => setEventIsStarGame(e.target.value)}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <option value="" disabled>
                        Is this event a star game?
                      </option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </Input>
                    <Button
                      onClick={createEvent}
                      className="primaryBtn"
                      style={{ marginTop: "0.5rem" }}
                      disabled={!homeTeam || !awayTeam}
                    >
                      CREATE EVENT
                    </Button>
                  </div>
                </div>
              </ModalBody>
            </Modal>
            {events?.length === 0 ? (
              <p style={{ textAlign: "center", marginBottom: "0.5rem" }}>
                No events created
              </p>
            ) : (
              events?.map((event) => {
                return (
                  <Button
                    key={event.id}
                    onClick={() => toggleEditEventModal(event)}
                    className="secondaryBtn"
                    style={{
                      marginBottom: "0.5rem",
                      boxShadow: event.result
                        ? "0px 0px 0px 3px #FABB00 inset"
                        : null,
                    }}
                  >
                    {event.isStarGame ? "⭐ " : null}
                    <span
                      style={{
                        color:
                          event.result === "Home" || event.result === "Draw"
                            ? "#FABB00"
                            : null,
                      }}
                    >
                      {event.homeTeam.toUpperCase()}
                    </span>{" "}
                    VS{" "}
                    <span
                      style={{
                        color:
                          event.result === "Away" || event.result === "Draw"
                            ? "#FABB00"
                            : null,
                      }}
                    >
                      {event.awayTeam.toUpperCase()}
                    </span>
                    {event.isStarGame ? " ⭐" : null}
                  </Button>
                );
              })
            )}
          </>
        )}
        <Modal
          id="editEventModal"
          isOpen={editEventModalIsVisible}
          toggle={toggleEditEventModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader" style={{ marginBottom: "1rem" }}>
              <div></div>
              <IoClose onClick={toggleEditEventModal} />
            </div>
            <div>
              <h1>EVENT</h1>
              <div style={{ marginTop: "1rem" }}>
                {new Date(group?.openingDateTime) > new Date() && (
                  <>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Home team
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={eventToEditHomeTeam}
                      onChange={(e) => setEventToEditHomeTeam(e.target.value)}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <option value="" disabled>
                        The event's home team
                      </option>
                      {
                        // eslint-disable-next-line
                        teams?.map((team) => {
                          if (team.league === league) {
                            return (
                              <option
                                key={team.name}
                                value={team.name}
                                disabled={
                                  team.name === eventToEditAwayTeam ||
                                  (team.league !== "NBA" &&
                                    team.league !== "MLB" &&
                                    team.league !== "NHL" &&
                                    teamsTaken.includes(team.name))
                                }
                              >
                                {team.name}
                              </option>
                            );
                          }
                        })
                      }
                    </Input>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Away team
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={eventToEditAwayTeam}
                      onChange={(e) => setEventToEditAwayTeam(e.target.value)}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <option value="" disabled>
                        The event's away team
                      </option>
                      {
                        // eslint-disable-next-line
                        teams?.map((team) => {
                          if (team.league === league) {
                            return (
                              <option
                                key={team.name}
                                value={team.name}
                                disabled={
                                  team.name === eventToEditHomeTeam ||
                                  (team.league !== "NBA" &&
                                    team.league !== "MLB" &&
                                    team.league !== "NHL" &&
                                    teamsTaken.includes(team.name))
                                }
                              >
                                {team.name}
                              </option>
                            );
                          }
                        })
                      }
                    </Input>
                  </>
                )}
                <div style={{ marginTop: "1rem" }}>
                  <div
                    className="roomGroupEventInfoRow"
                    style={{ marginBottom: 0 }}
                  >
                    <p
                      className="roomGroupEventVs"
                      style={{ width: "45%", marginBottom: 0 }}
                    >
                      HOME
                    </p>
                    <p
                      className="roomGroupEventVs"
                      style={{ marginBottom: 0 }}
                    ></p>
                    <p
                      className="roomGroupEventVs"
                      style={{ width: "45%", marginBottom: 0 }}
                    >
                      AWAY
                    </p>
                  </div>
                  <div
                    className="roomGroupEventInfoRow"
                    style={{ marginBottom: 0 }}
                  >
                    <p className="roomGroupEventHomeTeam">
                      {eventToEdit?.homeTeam?.toUpperCase()}
                    </p>
                    <p className="roomGroupEventVs">VS</p>
                    <p className="roomGroupEventAwayTeam">
                      {eventToEdit?.awayTeam?.toUpperCase()}
                    </p>
                  </div>
                  {eventToEdit?.result ? (
                    <>
                      <div className="eventYouVotedForContainer">
                        <p
                          style={{
                            color: "#FABB00",
                            fontWeight: 500,
                            marginBottom: 0,
                          }}
                        >
                          Result: {eventToEdit?.result}
                        </p>
                      </div>
                      <Button
                        onClick={revertResult}
                        className="primaryBtn"
                        style={{
                          marginTop: "0.5rem",
                          marginBottom: "0.5rem",
                          paddingTop: "0.5rem",
                          paddingBottom: "0.5rem",
                        }}
                      >
                        REVERT RESULT
                      </Button>
                    </>
                  ) : null}
                </div>
                {
                  // (new Date(group?.openingDateTime) > new Date()) ?
                  <>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Star game
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={eventToEditIsStarGame}
                      onChange={(e) => setEventToEditIsStarGame(e.target.value)}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <option value="" disabled>
                        Is this event a star game?
                      </option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </Input>
                    <Button
                      onClick={saveChangesToEvent}
                      className="primaryBtn"
                      style={{ marginTop: "0.5rem" }}
                      disabled={!eventToEditHomeTeam || !eventToEditAwayTeam}
                    >
                      SAVE CHANGES
                    </Button>
                    <Button
                      onClick={deleteEvent}
                      className="secondaryBtn"
                      style={{ marginTop: "0.5rem", color: "#005EE1" }}
                    >
                      DELETE EVENT
                    </Button>
                  </>
                  // :
                  // 	(!eventToEdit?.result && (new Date(group?.closingDateTime) < new Date())) &&
                  // 	<Button onClick={() => toggleSubmitEventResultModal(eventToEdit)} className='secondaryBtn' style={{marginTop: '0.5rem', color: '#005EE1'}}>
                  // 		SUBMIT RESULT
                  // 	</Button>
                }
                {!eventToEdit?.result &&
                  new Date(group?.closingDateTime) < new Date() && (
                    <Button
                      onClick={() => toggleSubmitEventResultModal(eventToEdit)}
                      className="secondaryBtn"
                      style={{ marginTop: "0.5rem", color: "#005EE1" }}
                    >
                      SUBMIT RESULT
                    </Button>
                  )}
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          id="submitEventResultModal"
          isOpen={submitEventResultModalIsOpen}
          toggle={toggleSubmitEventResultModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader" style={{ marginBottom: "1rem" }}>
              <div></div>
              <IoClose onClick={toggleSubmitEventResultModal} />
            </div>
            <div>
              <h1>SUBMIT RESULT</h1>
              <div style={{ marginTop: "1rem" }}>
                <Button
                  className="secondaryBtn"
                  style={{
                    marginBottom: "0.5rem",
                    backgroundColor: "#111835",
                    boxShadow: "0px 0px 0px 3px #111835 inset",
                  }}
                >
                  {eventToSubmitResult?.isStarGame ? "⭐ " : null}
                  {eventToSubmitResult?.homeTeam?.toUpperCase()} VS{" "}
                  {eventToSubmitResult?.awayTeam?.toUpperCase()}
                  {eventToSubmitResult?.isStarGame ? " ⭐" : null}
                </Button>
                <p className="inputLabel" style={{ textAlign: "left" }}>
                  Result
                </p>
                <Input
                  type="select"
                  className="mainInput"
                  value={eventToSubmitResultResult}
                  onChange={(e) => setEventToSubmitResultResult(e.target.value)}
                  style={{ marginBottom: "0.5rem" }}
                >
                  <option value="" disabled>
                    The event's result
                  </option>
                  <option value="Home">Home</option>
                  <option value="Away">Away</option>
                  <option value="Draw">Draw</option>
                </Input>
                <Button
                  onClick={submitEventResult}
                  className="primaryBtn"
                  style={{ marginTop: "0.5rem" }}
                  disabled={!eventToSubmitResultResult}
                >
                  SUBMIT
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
        {/* <p className='inputLabel' style={{textAlign: 'left'}}>
					Type
        </p>
				<Input
          type="select"
          className="mainInput"
					value={gameType}
          onChange={(e) => setGameType(e.target.value)}
					style={{marginBottom: '0.5rem'}}
        >
          <option value='' disabled>The event's type</option>
          <option value='Matchday'>Matchday</option>
					<option value='Week gameday'>Week gameday</option>
        </Input>
				<p className='inputLabel' style={{textAlign: 'left'}}>
					Home team
        </p>
				<Input
          type="select"
          className="mainInput"
					value={homeTeam}
          onChange={(e) => setHomeTeam(e.target.value)}
					style={{marginBottom: '0.5rem'}}
					disabled={!league}
        >
          <option value='' disabled>The event's home team</option>
					{
						// eslint-disable-next-line
						teams.map((team) => {
							if (team.league === league){
								return (
									// eslint-disable-next-line
									<option key={team.team} value={team.team} disabled={team.team == awayTeam}>{team.team}</option>
								)
							}
						})
					}
        </Input>
				<p className='inputLabel' style={{textAlign: 'left'}}>
					Away team
        </p>
				<Input
          type="select"
          className="mainInput"
					value={awayTeam}
          onChange={(e) => setAwayTeam(e.target.value)}
					style={{marginBottom: '0.5rem'}}
					disabled={!league}
        >
          <option value='' disabled>The event's away team</option>
					{
						// eslint-disable-next-line
						teams.map((team) => {
							if (team.league === league){
								return (
									// eslint-disable-next-line
									<option key={team.team} value={team.team} disabled={team.team == homeTeam}>{team.team}</option>
								)
							}
						})
					}
        </Input>
				{
					gameType === 'Matchday' ?
					<>
						<p className='inputLabel' style={{textAlign: 'left'}}>
							Matchday available time
						</p>
						<Input
							type="datetime-local"
							className="mainInput"
							value={matchdayAvaiableTime}
							onChange={(e) => setMatchdayAvailableTime(e.target.value)}
							style={{marginBottom: '0.5rem'}}
						/>
						<p className='inputLabel' style={{textAlign: 'left'}}>
							Matchday closing time
						</p>
						<Input
							type="datetime-local"
							className="mainInput"
							value={matchdayClosingTime}
							onChange={(e) => setMatchdayClosingTime(e.target.value)}
							style={{marginBottom: '0.5rem'}}
						/>
					</>
					:
					null
				}
				<p className='inputLabel' style={{textAlign: 'left'}}>
					Star game
				</p>
				<Input
					type="select"
					className="mainInput"
					value={isStarGame}
					onChange={(e) => setIsStarGame(e.target.value)}
					style={{marginBottom: '0.5rem'}}
				>
					<option value='' disabled>Is this a star game?</option>
					<option value='Yes'>Yes</option>
					<option value='No'>No</option>
				</Input> */}
        <Button
          onClick={saveGroupChanges}
          className="primaryBtn"
          style={{ marginTop: "1rem" }}
          disabled={
            !groupName ||
            !sport ||
            !league ||
            !openingDateTime ||
            !closingDateTime ||
            events?.length === 0
          }
        >
          SAVE CHANGES
        </Button>
        <Button
          onClick={deleteGroup}
          className="secondaryBtn"
          style={{ marginTop: "0.5rem" }}
        >
          DELETE GROUP
        </Button>
      </div>
    </div>
  );
}

export default AdminSingleGroupPage;
